import mixin from '../privates/utils/mixin';
import Background from './Background';
import ContainableMixin from './mixins/ContainableMixin';

/**
 * @class State
 * @summary A `State` from a [`MultiStateBox`]($w.MultiStateBox.html) that can contain other elements.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.StateBoxState
 * @definitionId wysiwyg.viewer.components.StateBoxState
 * @definitionId wysiwyg.viewer.components.StateStripState
 */

 /**
  * @member id
  * @label property
  * @syntax
  * get id(): string
  * @summary Gets the state's ID.
  * @description
  *  The ID is the state's unique identifier. It is used when selecting
  *  the state using the [`$w()`]($w.html#w) function.
  *
  *  An state's `id` is set in the Editor using the [Properties panel](https://support.wix.com/en/article/how-do-i-use-the-properties-panel).
  *  To set the state `id`:
  *
  *    1. Click the multi-state box.
  *    1. [Navigate](https://support.wix.com/en/article/velo-working-with-multi-state-boxes-4653920#navigate-your-states) to the state you want to edit.
  *    1. Edit the STATE ID field in the Properties panel.
  *
  *
  *  ![State ID](images/state_id.png "State ID")
  * @snippet [Multistatebox-currentState.es6=Get the current state and its ID]
  * @type {external:String}
  * @memberof $w.State
  * @override
  * @readonly
  */
class State extends Background {}

mixin(State.prototype, ContainableMixin.prototype);

export default State;
